import React from 'react'
import TrainingInfo from './TrainingInfo'

const GeneralTrainingInfoContainer = () => {
  return <TrainingInfo />
}

export default GeneralTrainingInfoContainer
